import { GenericStore, StringStore } from 'ui/base/input/store';
import { SearchInputStore } from 'ui/standard/input/search_input/search_input_store';
import { BandwidthUnit } from 'services/accounts/types';

class BandwidthUnitStore extends GenericStore<BandwidthUnit> {
}

export class BandwidthStore {
  string: StringStore;
  unit: BandwidthUnitStore;
  search: SearchInputStore;

  constructor(string: string, unit: BandwidthUnit) {
    this.string = new StringStore(string);
    this.unit = new BandwidthUnitStore(unit);
    this.search = new SearchInputStore();
  }
}

